export default {
  en: {
    menu: {
      orgDetails: 'Organisation details',
      products: 'Products and services',
      thirdParties: 'Critical 3rd parties',
      assets: 'Assets',
    },
    productSettings: {
      description: 'What products & services do you offer your clients?',
      add: 'Add product',
    },
    assetSettings: {
      subtitle: 'What public domains are associated with your services?',
    },
  },
};
